module.exports = __webpack_public_path__ + "static/media/001.e401787f.jpg";